import React from "react";
import { motion } from "framer-motion";

export const SectionHeader = ({ eyebrow, title, subtitle, align = "center", className = "" }) => {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      className={`flex flex-col ${alignCls} max-w-2xl ${className}`}
    >
      {eyebrow && (
        <span className="text-[10px] sm:text-xs text-[#3B9BE8] font-semibold tracking-[0.22em] uppercase mb-3">
          {eyebrow}
        </span>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-[0.02em] leading-[1.05]">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-sm sm:text-base text-white/65 leading-relaxed">{subtitle}</p>}
    </motion.div>
  );
};
